<script>
import DefaultLayout from "../layouts/DefaultLayout.vue";
import HelpPopup from '../HelpPopup.vue';

import { START } from "../../util/breadcrumbs.js";
import { has_feature } from "../../service/features.js";

export default {
    components: {
        "default-layout": DefaultLayout,
        "help-popup": HelpPopup
    },
    data: function() {
        return {
            breadcrumb: [START, {
                name: "Help",
                icon: "circle-question",
                link: "/help"
            }]
        };
    },
    methods: {
        has_feature
    }
};
</script>

<template>
  <default-layout title="Help" icon="circle-question" :breadcrumb="breadcrumb">
      <div class="row">
          <div class="col-2"></div>
          <div class="col-8">
              <h4>Introduction</h4>
              <p>
                  Popups for help are marked with a
                  <help-popup title="Intro">
                      Congrats, you opened a help-dialog :)
                  </help-popup>
                  where available and can be opened with a click.
              </p>
              <p>
                  You can come back here at any time with the "Help" button on the
                  <router-link to="/">Start</router-link> page.
              </p>
          </div>
          <div class="col-2"></div>
      </div>
  </default-layout>
</template>
